import { render, staticRenderFns } from "./ReviseShop.vue?vue&type=template&id=288fea8a&scoped=true&"
import script from "./ReviseShop.vue?vue&type=script&lang=js&"
export * from "./ReviseShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288fea8a",
  null
  
)

export default component.exports